import moment from "moment-timezone";
import jwt_decode from "jwt-decode";

const DateService = {
  /**
   * Devuelve el timezone del usuario (según su navegador)
   */
  getUserTimezone() {
    // 1) Preferir lo que venga en el JWT (lmsUserTimeZone)
    try {
      const token = window.$cookies?.get("LTI_JWT");
      if (token) {
        const jwtDecoded = jwt_decode(token);
        const jwtTz = jwtDecoded?.lmsUserTimeZone;
        if (jwtTz && moment.tz.zone(jwtTz)) {
          console.debug("[DateService] using jwt lmsUserTimeZone", jwtTz);
          return jwtTz;
        }
      }
    } catch (e) {
      console.warn("[DateService] jwt decode failed for timezone", e);
    }

    // 2) Navegador (si es IANA y no Etc/)
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (browserTz && moment.tz.zone(browserTz) && !browserTz.startsWith("Etc/")) {
      console.debug("[DateService] using browser timezone", browserTz);
      return browserTz;
    }

    // 3) Guess de moment
    const guessed = moment.tz.guess();
    if (guessed && moment.tz.zone(guessed) && !guessed.startsWith("Etc/")) {
      return guessed;
    }

    // 4) Último recurso
    console.warn("[DateService] fallback to UTC timezone");
    return "UTC";
  },

  /**
   * Convierte una fecha local del evento a UTC
   * Ej: "2026-03-31", "16:00", "Europe/Madrid" → "2026-03-31T14:00:00Z"
   */
  toUTC(date, time, eventTimezone) {
    const tz = eventTimezone && moment.tz.zone(eventTimezone)
      ? eventTimezone
      : this.getUserTimezone();
    return moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", tz)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  },

  /**
   * Convierte una fecha UTC a la zona del evento
   * Ej: "2026-03-31T14:00:00Z" → "2026-03-31 16:00"
   */
  utcToEvent(dateUTC, eventTimezone, format = "YYYY-MM-DD HH:mm") {
    return moment.utc(dateUTC).tz(eventTimezone).format(format);
  },

  /**
   * Convierte una fecha UTC a la zona del usuario
   * Ej: "2026-03-31T14:00:00Z" → "2026-03-31 10:00" (si el usuario está en América)
   */
  utcToUser(dateUTC, format = "YYYY-MM-DD HH:mm") {
    const tz = this.getUserTimezone();
    return moment.utc(dateUTC).tz(tz).format(format);
  },

  /**
   * Parsea un string fecha+hora desde la zona del usuario a UTC
   */
  userToUTC(date, time) {
    const tz = this.getUserTimezone();
    return moment
      .tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", tz)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
  }
};

export default DateService;